"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = buildIntroTimeline;
require("regenerator-runtime/runtime");
// setup
const helpers_1 = require("../shared/helpers");
const instructions_1 = require("./trials/instructions");
const taskSetup_1 = require("../taskSetup");
// trials
const trials_1 = require("../shared/trials");
function buildIntroTimeline(config, mediaAssets) {
    const preloadTrials = (0, helpers_1.createPreloadTrials)(mediaAssets).default;
    (0, helpers_1.initTrialSaving)(config);
    const initialTimeline = (0, helpers_1.initTimeline)(config, trials_1.enterFullscreen);
    const timeline = [preloadTrials, initialTimeline, ...instructions_1.instructions];
    timeline.push((0, trials_1.taskFinished)('introFinished'));
    timeline.push(trials_1.exitFullscreen);
    return { jsPsych: taskSetup_1.jsPsych, timeline };
}
